export const client = async (
  endpoint: string,
  { body, ...customConfig }: any = {}
) => {
  const headers = { 'Content-Type': 'application/json' };
  const config = {
    method: body ? 'POST' : 'GET',
    ...customConfig,
    headers: {
      ...headers,
      ...customConfig.headers,
      ...(customConfig.withCredentials && { credentials: 'include' }),
    },
  };

  if (body) {
    config.body = JSON.stringify(body);
  }

  const response = await fetch(endpoint, config);

  if (response.ok) {
    return await response.json();
  } else {
    const errorMessage = await response.json();
    return Promise.reject(errorMessage);
  }
};
